import { type SVGProps } from 'react';

// eslint-disable-next-line import/no-duplicates
import { ReactComponent as XpIcon } from '@/assets/images/XP.svg?react';

// eslint-disable-next-line import/no-duplicates
import xpIconUrl from '@/assets/images/XP.svg';

import { Icon } from '../icon';

interface Props extends SVGProps<SVGSVGElement> {
  renderAs?: 'inline' | 'img';
}

const ICON_BY_RENDER_AS = {
  inline: XpIcon,
  img: xpIconUrl,
} as const;

export const XPIcon = ({ renderAs = 'inline', ...props }: Props) => {
  return <Icon icon={ICON_BY_RENDER_AS[renderAs]} {...props} />;
};
